import axios, { type AxiosRequestConfig } from 'axios';

import { CoreJsonAPIResponse } from '../CoreJsonAPIResponse';
import type { EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';

export default class CoreJsonAPIService {
  protected static async get<T>(
    djangoApp: EDjangoAppsEndpoints,
    suffix: string = '',
    params?: Record<string, any>,
    config?: AxiosRequestConfig
  ) {
    return new CoreJsonAPIResponse<T>(
      await axios.get(`/api/${djangoApp}/${suffix}`, {
        ...config,
        params
      })
    );
  }

  protected static async put<T>(
    djangoApp: EDjangoAppsEndpoints,
    suffix: string = '',
    data?: Record<string, any>,
    config?: AxiosRequestConfig
  ) {
    return new CoreJsonAPIResponse<T>(await axios.put(`/api/${djangoApp}/${suffix}`, data, config));
  }

  protected static async post<T>(
    djangoApp: EDjangoAppsEndpoints,
    suffix: string = '',
    data?: Record<string, any>,
    config?: AxiosRequestConfig
  ) {
    return new CoreJsonAPIResponse<T>(await axios.post(`/api/${djangoApp}/${suffix}`, data, config));
  }

  protected static async delete<T>(djangoApp: EDjangoAppsEndpoints, suffix: string = '', config?: AxiosRequestConfig) {
    return new CoreJsonAPIResponse<T>(await axios.delete(`/api/${djangoApp}/${suffix}`, config));
  }

  /**
   * Method to download a file using HTTP GET.
   * @param djangoApp
   * @param suffix
   * @param params
   * @param config
   * @protected
   */
  protected static async getFileResponse(
    djangoApp: EDjangoAppsEndpoints,
    suffix: string = '',
    params?: Record<string, any>,
    config?: AxiosRequestConfig
  ) {
    return new CoreJsonAPIResponse<Blob>(
      await axios.get(`/api/${djangoApp}/${suffix}`, {
        params,
        ...config,
        responseType: 'blob' // Overrides response type in config
      })
    );
  }
}
